export class ParsedDateRange {
    constructor(props) {
        this.from = new Date(props.from);
        this.to = new Date(props.to);
    }
}
